import { IComponentController } from 'angular';
import { IFilterExDate } from '../../../../../core/filters/ex-date.filter';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IStateParamsService } from 'angular-ui-router';

interface IPageRc0006 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    rciMultiOccurrenceOptions: IMultiOccurrenceOptions;
}


/* @ngInject */
export default function Rc0006Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemAction: IMenuItemActionClass,
    exDateFilter: IFilterExDate,
    MenuItemForage: IMenuItemForageClass,
    $stateParams: IStateParamsService,
    rc0002Route: IRoute,
    in1000Route: IRoute) {
    const vm: IPageRc0006 = this;

    const docTxm = [
        new MenuItemForage(
            'BTN_FORAGE_PFL',
            rc0002Route.NAME,
            (data: any) => ({
                id: data.doccleintref
            }),
            {
                fonction: 'BOUDAC',
                icon: 'exit_to_app'
            }
        )
    ];

    vm.monoOccurrenceOptions = {
        fonctions: {
            boutonDupliquer: false
        },
        infosMonetaires: {
            blocs: ['rci'],
            donnees:
                [
                    { nom: 'txmmnt', libelle: 'LBL_TOT' }
                ]
        },
        menus: [
            new MenuItemForage(
                'G_LBL_IMPACT_INV', 
                in1000Route.NAME, (data:any) => ({ doccleint: data.doccleint }),
                {
                    iconButton: false,
                    icon: 'subtitles',
                    secondaire: true  
                }
            ),
            new MenuItemAction(
                'LBL_BTN_FORMULAIRE_CEN',
                'BOUFORCEN',
                () => ({}),
                {
                    iconButton: false,
                    icon: 'print',
                    fonction: 'BOUFORCEN',
                    secondaire: true,
                    formulaireConfirmationAction: {
                        lblTitre: 'LBL_BTN_FORMULAIRE_CEN',
                        lblConfirm: 'G_LBL_BTN_APPLIQUER',
                        largeurFormulaire: 30,
                        formulaire: new Formulaire([
                            new FormulaireItem('trlcodcen')
                        ])
                    }
                }
            )
        ],
        formulaire: new Formulaire('LBL_BLC_TXM', [
            new FormulaireItem('magcleint'),
            new FormulaireItem('txmflgpij'),
            new FormulaireItem('txmnumdoc'),
            new FormulaireItem('tydcleint'),
            new FormulaireItem('refcleint'),
            new FormulaireItem('doccleintref', { menu: docTxm }),
            new FormulaireItem('intcleintmag'),
            new FormulaireItem('intcleintreq'),
            new FormulaireItem('intcleintdem'),
            new FormulaireItem('peccleint'),
            new FormulaireItem('txmdat', { default: exDateFilter(new Date()) }),
            new FormulaireItem('txmdatreq'),
            new FormulaireItem('vectxmcat'),
            new FormulaireItem('txmdsc', { largeur: 66.66, enableCount: true }),
        ], { largeurDefaut: 33.33 }
        )
    };

    // ligne
    vm.rciMultiOccurrenceOptions = {
        bloc: 'rci',
        fonctions: {
            boutonDupliquer: false
        },
        colonnesVisibles: [
            { nom: 'procod', largeur: 100 },
            { nom: 'prodsc', largeur: 210 },
            { nom: 'forcod', largeur: 150 },
            { nom: 'fordsc', largeur: 150 },
            { nom: 'vecrciremsto', largeur: 120 },
            { nom: 'rcicom', largeur: 120 },
            { nom: 'vaercirem', largeur: 140 },
            { nom: 'vaedsc', largeur: 150 }
        ],
        colonnesFixesDroite: [
            { nom: 'rciqte', largeur: 120 },
            { nom: 'rciqtefor', largeur: 120 },
            { nom: 'rciprxuni', largeur: 120 },
            { nom: 'rcimnttot', largeur: 120 },
            { nom: 'rciflgmsg', largeur: 100 }
        ],
        colonnesCachees: ['rciligref'],
        formulaire: new Formulaire([
            new FormulaireItem('procleint', {
                resourceParams: (data: any) => ({
                    doccleintref: data.$ancetre.doccleintref
                })
            }),
            new FormulaireItem('forcleint'),
            new FormulaireItem('vecrciremsto'),
            new FormulaireItem('rcicom'),
            new FormulaireItem('vaercirem'),
            new FormulaireItem('rciqte'),
            new FormulaireItem('rciqtefor', {
                largeur: 25
            }),
            new FormulaireItem('rciprxuni', {
                largeur: 25
            }),
            new FormulaireItem('rcimnttot', {
                largeur: 25
            }),
            new FormulaireItem('rciflgmsg', {
                largeur: 25
            })
        ])
    };

}
